import moment from 'moment';
import * as XLSX from 'xlsx';

const config = {
    priceDecimal: 8
}

function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

const digitFormat = {
    minimumFractionDigits: 4,
    maximumFractionDigits: 4
};

const formatLang = (val) => {
    let currentLang = val;
    currentLang = currentLang.replace(' ','');
    currentLang = currentLang.replace('(','');
    currentLang = currentLang.replace(')','');
    return currentLang;
}

function deepCopyArray(arr) {
    return arr.map(item => ({ ...item }));
}

const formatTwoDecimal = (num) => {
    let truncatedNumber = Math.floor(num * 100) / 100;
    return Number(truncatedNumber);
}

const downloadExcel = (data, fileName) => {
    let date = moment(new Date()).format('YYYYMMDDHHmmss');
    let excelFileName = `${fileName}_${date.toString()}.xlsx`;
    const wb = XLSX.utils.book_new();
    var ws = XLSX.utils.json_to_sheet(data && data.length > 0 ? data : []);
    XLSX.utils.book_append_sheet(wb, ws, "Report");
    XLSX.writeFile(wb, excelFileName)
}

function checkType(value) {
    if (typeof value === 'string') {
      return 'string';
    } else if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
      return 'object';
    } else {
      return 'unknown';
    }
}

const truncateToTwoDecimals = (num) => {
    const str = num.toString();
    const decimalIndex = str.indexOf('.');
  
    if (decimalIndex === -1) return str; // No decimal point, return the number as is
  
    return str.substring(0, decimalIndex + 3); // Get the part up to two decimal places
};

export { checkType, config, deepCopyArray, digitFormat, downloadExcel, formatLang, formatTwoDecimal, numberWithCommas, truncateToTwoDecimals };
